/**
 * DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATE
 * DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATED! DEPRECATE
 * DO NOT USE THIS FILE. If you need anything in here, remove it to a helper function and require that.
 *
 * Set up global variable to store application globals and pass info.
 *
 * Note: The routes property is intended to be reserved for ajax routes, not Backbone routes.
 *
 */
'use strict';

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var root = window || global;
var document = root.document || {};

// todo: move this somewhere better
// General JS for all pages  : NOTICE! The following JS will be executed on all pages. Please be extremely
// discriminating when putting Js in the following code block!
$(document).ready(function() {
    var matches;
    var mobileOS = false;
    var ua = root.navigator ? root.navigator.userAgent : undefined;
    var $html = $('html');

    // ----------------------//
    // TESTING FOR MOBILE OS //
    // ----------------------//

    // In order to determine if this is a mobile OS we have to scan the user agent. If it matches
    // one of the options in our RegEx we add a class to the html tag. If it matches Android, we add
    // the class 'android', and so on. Test with $('html').hasClass('android'). All mobile users will
    // have the class 'mobile' added to their html tag. iOS devices have the additional class 'ios'.
    // If there are no mobile os matches, we add the class non-touch
    if (ua) {
        matches = ua.match(/\b(Android|iPhone|iPad|BlackBerry|iPod|webOs)\b/i);
        if (matches) {
            mobileOS = matches[0];
            $html.addClass(mobileOS.toLowerCase()).addClass('mobile');
            if (mobileOS.charAt(0) === 'i') {
                $html.addClass('ios');
            }
        } else {
            $html.addClass('non-touch');
        }
    }
});

// don't stomp the global if it exists already
// also make sure to assign to root.dibs
var dibs = (root.dibs = root.dibs || {});

// The admin home page (so we redirect to the proper pages)
// For now this goes to legacy, but eventually it might be just /
// TODO :: This should be a server var!!!!!!
dibs.ADMIN_HOME_URL = 'http://furniture.admin.1stdibs.com/';

// todo: exporting this right to global equals no-no
root.log = function() {
    root.log.history = root.log.history || []; // store logs to an array for reference
    root.log.history.push(arguments);
    console.log(Array.prototype.slice.call(arguments));
};

// BROWSER DETECTION functions here. nice.
dibs.isIE = function() {
    return $('html').hasClass('ie');
};

dibs.isLtIE10 = function() {
    return $('html').hasClass('lt-ie10');
};

dibs.isLtIE9 = function() {
    return $('html').hasClass('lt-ie9');
};

dibs.isLtIE8 = function() {
    return $('html').hasClass('lt-ie8');
};

dibs.parseUri = function(str, mode) {
    var options = {
            key: [
                'source',
                'protocol',
                'authority',
                'userInfo',
                'user',
                'password',
                'host',
                'port',
                'relative',
                'path',
                'directory',
                'file',
                'query',
                'anchor',
            ],
            q: {
                name: 'queryKey',
                parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
            },
            parser: {
                strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
                loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
            },
        },
        m = options.parser[mode || 'loose'].exec(str),
        uri = {},
        i = 14;

    while (i--) {
        uri[options.key[i]] = m[i] || '';
    }

    uri[options.q.name] = {};
    uri[options.key[12]].replace(options.q.parser, function($0, $1, $2) {
        if ($1) {
            uri[options.q.name][$1] = $2;
        }
    });

    return uri;
};

/*
 * createNamespace - creates an empty object under the passed in namespace
 *  - if the namespace exists, it returns that object
 *  @param ns String A period delimited string of the namespace: "my.new.name.space"
 *  @param fn Function Ability to assign a method to the namespace
 *  @param args Mixed Looking for an object of arguments to pass into the @fn, can be null or an empty string as well
 *  @param instantiate Boolean This is only used if a @fn is passed in
 */
dibs.createNamespace = function(ns, Fn, args, instantiate) {
    var nsArray = ns.split('.');
    var nsLen = nsArray.length;
    var root = window;
    var target;

    while (nsLen > 1) {
        var newNs = nsArray.shift();
        if (typeof root[newNs] === 'undefined') {
            root[newNs] = {};
        }
        root = root[newNs];
        nsLen = nsArray.length;
    }

    target = nsArray.shift();

    if (!root[target]) {
        if (Fn) {
            root[target] = typeof Fn === 'function' && instantiate ? new Fn(this, args) : Fn;
        } else {
            root[target] = {};
        }
    }

    return root;
};

//-----------------------//
// Prototype Inheritance //
//-----------------------//

/**
 * Paradigm for being able to take functionality
 * from a functions prototype and be able to overwrite
 * specific functions and properties of that prototype
 * without overwriting the parent's prototype and
 * without having to attach the functions to specific
 * instances.
 *
 * Example:
 *      MyFunc = function () { };
 *      MyFunc.prototype.sayHi = function () {
 *          console.log(this.hi);
 *      };
 *
 *      MyChildFunc = function (hi) {
 *          this.hi = hi;
 *      };
 *
 *      MyGrandChildFunc = function (hi) {
 *          MyGrandChildFunc.__super__.constructor.call(this, hi);
 *          this.hi = this.hi + ' from GrandChildFunc';
 *      }
 *
 *      dibs.protoInherit(MyChildFunction, MyFunc);
 *
 *      new MyChildFunc('hello').sayHi(); // Logs 'hello'
 *      new MyGrandChildFunc('And hello'); // Logs 'And hello from GrandChildFunc'
 *
 * @param {Function} child Child constructor function
 * @param {Function} parent Parent constructor function
 * @return void
 */
dibs.protoInherit = (function() {
    // This function doesn't ever need to change,
    // so we'll initialize it once
    var F = function() {};

    return function(child, parent) {
        F.prototype = parent.prototype;
        child.prototype = new F();
        child.__super__ = parent.prototype;
        child.prototype.constructor = child;
    };
})();

/**
 * Very simple utility function to kill an event.
 * @param e
 */
dibs.killE = function(e) {
    if (e) {
        if (e.preventDefault && e.stopPropagation) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
};

/**
 * Retreives a JSON object from the responseText attribute of an XHR object. This is useful for retreiving
 * JSON messages that come back on service failures, or requests that bomb out in PHP, but have valid JSON
 * response bodies.
 * @param xhr
 * @returns {*}
 */
dibs.getJsonFromError = function(xhr) {
    var json = xhr.responseText,
        output = null;

    // If the response text was found, and it's a string, then try to decode it. If not, then return null
    if (json && !_.isObject(json) && typeof json === 'string') {
        // Parse the JSON using try-catch so JS doesn't throw a fit:
        if (json) {
            try {
                output = JSON.parse(json);
            } catch (e) {
                return null;
            }
        }
        return output;
    }
    return null;
};

/**
 * Unescape in JS for ASCII characters that we regularly encounter:
 * @param string <str>
 */
dibs.unescape = function(string) {
    // First check for index of '&' - because ALL ascii replacements will have this.  This avoids doing unnecessary
    // iterations if the string contains no characters to be escaped or unescaped.
    if (string && typeof string === 'string' && string.indexOf('&') !== -1) {
        return _escapeOrUnescape(string, false);
    } else {
        return string;
    }
};

/**
 * Escape ASCII characters in JS:
 * @param string <str>
 */
dibs.escape = function(string) {
    // Note: escape has no check to do, it HAS to iterate over all of the characters in the escape map to determine
    // whether they exist in the string.
    return _escapeOrUnescape(string, true);
};

/**
 * This is a utility function to display text that may be either escaped, or unescaped, as in our database.
 * @param string
 * @return {string}
 */
dibs.displayEscapedText = function(string) {
    return dibs.escape(dibs.unescape(string));
};

// Escape map for escaping and unescaping strange ASCII characters we regularly encounter in JS:
dibs.escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;',
    Å: '&Aring;',
    å: '&aring;',
    À: '&Agrave;',
    à: '&agrave;',
    Ç: '&Ccedil;',
    ç: '&ccedil;',
    É: '&Eacute;',
    é: '&eacute;',
    Ê: '&Ecirc;',
    ê: '&ecirc;',
    Ë: '&Euml;',
    ë: '&euml;',
    È: '&Egrave;',
    è: '&egrave;',
    Ö: '&Ouml;',
    ö: '&ouml;',
    Ø: '&Oslash;',
    ø: '&oslash;',
    Ü: '&Uuml;',
    ü: '&uuml;',
};

/**
 * Helper function to dry up the unescaping & escaping.
 * @param string <str> - The string to be unescaped or escaped
 * @param escape <bool> - Boolean flag indicating unescaping or escaping. pass TRUE for escape.
 * @return {*}
 * @private
 */
var _escapeOrUnescape = function(string, escape) {
    var newStr = string;
    if (newStr && typeof newStr === 'string') {
        _.each(dibs.escapeMap, function(ascii, character) {
            var substr = escape ? character : ascii;
            var replacement = escape ? ascii : character;
            if (newStr.indexOf(substr) !== -1) {
                var arr = newStr.split(substr);
                newStr = arr.join(replacement);
            }
        });
    }
    return newStr;
};

/**
 * Utility function to get an object reference from a string.
 * @param string
 * @return {Object} - the reference to the object indicated by the string
 * Example:
 *      var obj = dibs.getReferenceFromString('dibs.name.space.heytimifyouarereadingthisijusthitthebalmerpeak');
 */
dibs.getReferenceFromString = function(string) {
    var arr = string.split('.');
    var ref = window;
    var x;

    for (x in arr) {
        if (ref[arr[x]]) {
            ref = ref[arr[x]];
        } else {
            return null;
        }
    }
    return ref ? ref : null;
};

module.exports = dibs;
